<template>
    <span id="why-main">
        <div class="touple triple">
			<div @click="openLink('https://www.ncbi.nlm.nih.gov/pmc/articles/PMC5767492/')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/cbd5blur.jpg')}')`}">
				<h3>Care For Your Brain</h3>
			</div>
            <div @click="openLink('https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3079847/')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/cbd2blur.jpg')}')`}">
                <h3>Care For Your Spirit</h3>
            </div>
            <div @click="openLink('https://www.ncbi.nlm.nih.gov/pubmed/16698671')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/cbd1blur.jpg')}')`}">
                <h3>Care For Your Body</h3>
            </div>
        </div>
		<div class="touple solo">
            <div @click="openLink('https://www.ncbi.nlm.nih.gov/pubmed/17157290')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/cbd3blur.jpg')}')`}">
                <h3>Live Pain Free</h3>
            </div>
		</div>
        <div class="touple">
            <div @click="openLink('https://www.netdoctor.co.uk/healthy-living/a25854145/cbd-oil-sleep/')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/cbd4blur.jpg')}')`}">
                <h3>Rest Easy</h3>
            </div>
            <div @click="openLink('https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3579246/')" class="card" :style="{backgroundImage: `url('${require('../assets/stock/cbd6blur.jpg')}')`}">
                <h3>Fight Cancer</h3>
            </div>
        </div>
    </span>
</template>

<script>
export default {
    methods: {
        openLink(link) {
            window.open(link, '_blank')
        }
    }
}
</script>

<style lang="scss">
    #why-main {
		margin-bottom: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
		.card {
			cursor: pointer;
            text-align: center;
		}
    }
</style>
